import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import user from '../views/user.vue'
import privacy from '../views/privacy.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/user',
    name: 'user',
    component: user
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: privacy
  },
 
]

const router = new VueRouter({
  routes
})

export default router
